import { TablePaginationPlaceholder } from 'shared/placeholders';
import { TablePagination } from '../components/TablePagination/TablePagination';
import { Pageable } from '../models/Pageable';
import { useDataFetcher } from 'shared/http';
import { Alert } from '@orbita-ui/core';
export interface TableComponentParams<T> {
  tableContent: T[];
  placeholderRows?: number;
}

type TableComponent<T> = (props: TableComponentParams<T>) => any;

export function withPagination<T>(TableComponent: TableComponent<T>) {
  return (props: {
    dataFetcherFunction: (status: {
      pageNumber: number;
      pageSize: number;
    }) => Promise<Pageable<T>>;
    pageableInit?: Pageable<T>;
    loadingState?: boolean;
    noResultsMessages?: string;
    [key: string]: any;
  }) => {
    const [pageable, setRequest] = useDataFetcher<Pageable<T>>(props.pageableInit);

    const onChangePaginationStatus = (status: {
      pageNumber: number;
      pageSize: number;
    }) => {
      setRequest(() => props.dataFetcherFunction(status));
    };

    return (
      <>
        {props.loadingState || pageable.data?.content?.length ? (
          <div className="pt-3">
            <TableComponent
              tableContent={
                !pageable.isLoading && !props.loadingState ? pageable.data?.content : null
              }
              placeholderRows={pageable.data?.content.length}
              {...props}
            ></TableComponent>
            {props.loadingState || !pageable.data?.content ? (
              <TablePaginationPlaceholder />
            ) : (
              <TablePagination
                pageable={pageable.data}
                onChangePaginationStatus={(status) => onChangePaginationStatus(status)}
              ></TablePagination>
            )}
          </div>
        ) : (
          <div className="p-3">
            <Alert
              variant="info"
              fullWidth
              subtitle={props.noResultsMessages || 'No se encontraron resultados'}
            />
          </div>
        )}
      </>
    );
  };
}
